import API, { handleRequest } from "@/api/lib/api";

export const getServiceChargeSettings = async (restaurant_id) =>
  handleRequest(() =>
    API.get(`online-order/settings/restaurant/${restaurant_id}/service-charge`)
  );

export const updateServiceChargeSettings = async (restaurant_id, data) =>
  handleRequest(() =>
    API.put(`online-order/settings/restaurant/${restaurant_id}/service-charge`, data)
  );
